import {
  getSetPublicAction,
} from '@/utils/common/tableActions'

export default {
  data () {
    return {
      singleActions: [
        {
          label: this.$t('common.delete'),
          permission: 'bill_analysis_reports_delete',
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              data: [obj],
              columns: this.columns,
              title: this.$t('common.delete'),
              name: this.$t('bill.analysis_report'),
              onManager: this.onManager,
            })
          },
        },
        getSetPublicAction(this, {
          name: this.$t('bill.analysis_report'),
          scope: 'project',
          resource: 'bill_analysis_reports',
        }, {
          permission: 'bill_analysis_reports_perform_public',
        }),
      ],
    }
  },
}
